module.exports = __webpack_public_path__ + "static/media/011.e37badce.jpg";